import styled, { css } from 'styled-components'
import { theme } from '@notino/react-styleguide'

// utils
import { resetButtonStyles, screenReaderOnly, truncate } from '../../styles/helpers'

// components
import Input from '../Input/Input'

export const SelectWrapper = styled.div`
	position: relative;
`

export const PrefixIconWrapper = styled.div<{ $isDisabled?: boolean }>`
	position: absolute;
	z-index: 1;
	left: 1rem;
	width: 1.25rem;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	pointer-events: none;
	color: ${({ $isDisabled }) => ($isDisabled ? theme.color.text.disabled : theme.color.text.primary)};

	svg {
		width: 1.25rem;
		height: 1.25rem;
	}
`

export const ClearButton = styled.button`
	${resetButtonStyles};
	position: absolute;
	right: 1rem;
	top: 50%;
	transform: translateY(-50%);
	z-index: 2;
	width: 1.25rem;
	height: 1.25rem;
	display: flex;
	align-items: center;
	justify-content: center;
	color: ${theme.color.text.tertiary};
	background-color: ${theme.color.background.primary};

	svg {
		width: 100%;
		height: 100%;
	}

	&:hover,
	&:focus-visible {
		color: ${theme.color.text.primary};
	}
`

export const DropdownStateWrapper = styled.div`
	min-height: 6.25rem;
`

export const DropdownMenuKeeper = styled.div<{ $hidden?: boolean }>`
	${({ $hidden }) =>
		$hidden &&
		css`
			position: absolute;
			width: 0.0625rem;
			height: 0.0625rem;
			padding: 0;
			margin: -0.0625rem;
			overflow: hidden;
			clip: rect(0, 0, 0, 0);
			white-space: nowrap;
			border: 0;
			pointer-events: none;
		`}
`

export const StatusMessage = styled.div`
	${screenReaderOnly};
`

// Mobile drawer list
export const MobileListWrapper = styled.div`
	width: 100%;
	height: 100%;
`

export const MobileSearchWrapper = styled.div``

export const MobileSearchInput = styled(Input)`
	&.rc-input-affix-wrapper {
		background-color: ${theme.color.background.primary};
		padding: 0.75rem 0;
		margin-left: -0.625rem;
		outline: none;
		border: none;

		input {
			background-color: ${theme.color.background.primary};
		}
	}
`

export const MobileListBox = styled.div<{ $isDisabled?: boolean }>`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	outline: none;
`

export const MobileListBoxItem = styled.div<{ $isSelected: boolean; $isHighlighted: boolean }>`
	padding: 0.625rem 1.25rem;
	min-height: 2.75rem;
	display: flex;
	align-items: center;
	justify-content: space-between;
	overflow: hidden;
	gap: 0.5rem;
	cursor: pointer;
	${theme.typography.labelRegular400};
	flex-shrink: 0;

	&:hover {
		background-color: ${theme.color.background.secondary};
	}

	${({ $isSelected }) =>
		$isSelected &&
		css`
			background-color: ${theme.color.background.secondary};
		`}

	${({ $isHighlighted }) =>
		$isHighlighted &&
		css`
			background-color: ${theme.color.background.tertiary};
			outline: 0.125rem solid ${theme.color.border.selected};
			outline-offset: -0.125rem;
		`}
`

export const MobileMenuItemText = styled.div`
	${truncate};
	width: 100%;
`

export const MobileMenuItemIconWrapper = styled.div`
	flex-shrink: 0;

	svg {
		width: 1.25rem;
		height: 1.25rem;
	}
`
